import PropTypes from 'prop-types'

const
    type = PropTypes.oneOf(['normal', 'bold', false]),

    weight = value => ({fontWeight: value || 'normal'})

export {weight, type}
